<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>



<div class="container pt-5">
    <div class="d-flex flex-row bd-highlight">
        <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">
            
            <div class="list-group my-3">
                <li class="list-group-item list-group-item-action bg-dark text-white" disable>
                    <h2 class="text-capitalize">GoPNG Profile</h2>
                    <span style="font-size: 12px;">Government of Papua New Guinea Profile</span>
                </li>
                <li class="list-group-item list-group-item-action bg-secondary text-white" disable>
                    <h3 class="text-capitalize">Institutions</h3>
                </li>

                <a class="list-group-item list-group-flush" 
                    (click)="routeToGovernmentListPage(doc.name)" routerLink=""
                    *ngFor="let doc of governmentNationalCol | async">                
                    <div class="media">                        
                        <!-- <img *ngIf="!item.logo" [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <img *ngIf="item.logo" [src]="item.logo" class="mr-3 align-self-center rounded-circle image" alt="..."> -->
                        <div class="media-body">
                            <h3 class="float-left">{{ doc.name }}</h3>
                            <span class="float-right font-weight-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                                  </svg>
                            </span>
                        </div>
                    </div>                
                </a> 
                <!-- Local Territory List -->
                <a class="list-group-item list-group-flush" 
                    (click)="routeToGovernmentTerritoryListPage(doc.name)" routerLink=""
                    *ngFor="let doc of governmentLocalCol | async">                
                    <div class="media">                        
                        <!-- <img *ngIf="!item.logo" [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <img *ngIf="item.logo" [src]="item.logo" class="mr-3 align-self-center rounded-circle image" alt="..."> -->
                        <div class="media-body">
                            <h3 class="float-left">{{ doc.name }}</h3>
                            <span class="float-right font-weight-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                                  </svg>
                            </span>
                        </div>
                    </div>                
                </a> 
                <li class="list-group-item list-group-item-action bg-dark" disable>
                    <!-- <h2>Popular Business Category</h2> -->
                </li>    
            </div>

        </div>
    </div>
</div>


